import { useMutation } from '@tanstack/react-query';
import { userSignupApi } from './auth.api'; // adjust path as needed
import { SignupPayload } from 'types/signup';

export const useUserSignupMutation = () => {
  return useMutation({
    mutationFn: (payload: SignupPayload) => userSignupApi(payload),
  });
};